
import './add';
import './appointment';
import './util';

import './appointments.component.js';
import './appointments.controller.js';
import './appointments.service.js';
import './_appointments.styles.scss';
import './_appointments-legend.styles.scss';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES, moment) {
  $stateProvider
  .state('inkfinder.appointments', {
    abstract: true,
    url: '/appointments'
  })
  .state('inkfinder.appointments.days', {
    url: '/{year:[0-9]{1,4}}/{month:[0-9]{1,4}}/{day:[0-9]{1,4}}',
    views: {
      '@': {
        component: 'inkAppointments'
      }
    },
    params: {
      month: {
        value: moment().format('MM'),
        dynamic: true
      },
      year: {
        value: moment().format('YYYY'),
        dynamic: true
      },
      day: {
        value: moment().format('DD'),
        dynamic: true
      }
    },
    resolve: {
      $title: (() => 'Schedule')
    },
    data: {
      authorizedRoles: [USER_ROLES.operator, USER_ROLES.artist]
    },
    bindings: {
      $transition$: '<'
    }
  });
});



// WEBPACK FOOTER //
// ./components/appointments/index.js